import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from '../../models/question-base';

@Component({
  selector: 'app-question',
  templateUrl: './dynamic-form-question.component.html',
  styleUrls: ['./dynamic-form-question.component.css']
})
export class DynamicFormQuestionComponent {
  @Input() question!: QuestionBase;
  @Input() form!: FormGroup;
  @Output() onEvent = new EventEmitter()
  get isValid() { return this.form.controls[this.question.key].valid; }
  onChange(event: any) {

  }

  onBlur(event: any) {
    console.log('EVENT BLUR :: ' + JSON.stringify(event))
    const keyValue:string = this.form.value[this.question.key];
    if(keyValue && keyValue.length > 3){
      this.onEvent.emit('BLUR');
    }
  }
}
